var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00024 6.84692C8.5568 6.84692 9.81876 5.3142 9.81876 3.42348C9.81876 1.53272 9.40444 0 7.00024 0C4.59604 0 4.18164 1.53272 4.18164 3.42348C4.18164 5.3142 5.4436 6.84692 7.00024 6.84692Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3242 12.1643C12.3257 12.1327 12.3247 11.9453 12.3242 12.1643V12.1643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3169 11.9359C12.2647 8.64222 11.8345 7.7037 8.54278 7.10962C8.54278 7.10962 8.07942 7.70006 6.99942 7.70006C5.91942 7.70006 5.45598 7.10962 5.45598 7.10962C2.20018 7.69722 1.74386 8.62182 1.68386 11.8289C1.67894 12.0908 1.67666 12.1045 1.67578 12.0741C1.67598 12.1311 1.67622 12.2365 1.67622 12.4202C1.67622 12.4202 2.4599 14 6.99942 14C11.5389 14 12.3226 12.4202 12.3226 12.4202C12.3226 12.3022 12.3227 12.2201 12.3228 12.1642C12.3219 12.183 12.3202 12.1466 12.3169 11.9359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.24815176.svg";
export { ForwardRef as ReactComponent };